import React from "react";
import { DivWrapper } from "./sections/DivWrapper";
import { Flexcontainer } from "./sections/Flexcontainer";
import { FlexcontainerWrapper } from "./sections/FlexcontainerWrapper";
import "./style.css";

export const MoneyBackPolicy = ({
    clickNext = () => {},
    clickPrev = () => {},
                            }) => {
  return (
    <div className="money-back-policy">
      <div className="container-2">
        <div className="title">MONEY-BACK POLICY</div>

        <Flexcontainer />
        <div className="section">
          <div className="title-2">Money-back Guarantee Rules</div>
        </div>

        <FlexcontainerWrapper />
        <div className="section">
          <div className="title-2">General Money-back Rules</div>
        </div>

        <p className="body-text">
          We value your feedback and are committed to ensuring you are satisfied
          with our products and services. If you are not completely satisfied
          with our service, you may request a money-back in accordance with the
          terms of this policy.
          <br />
          In general, if you do not meet the conditions of the money-back
          guarantee, the fees you paid are non-refundable and non-exchangeable
          unless otherwise stated or required by law. Additionally, some
          money-back requests may be decided based on specific circumstances. We
          reserve the right to decline repeat or fraudulent refund requests, as
          determined in our sole discretion.
          <br />
          Money-back requests can typically only be made during the subscription
          period. If your subscription period has expired before you submit your
          money-back request, we will not be able to process your money-back.
          <br />
          Important Notes for Residents of Specific Regions
          <br />
          California and Connecticut Residents: If you cancel your order at any
          time, and before midnight on the third business day following your
          purchase, we will refund your payment.
          <br />
          EU Residents: If you are a consumer in the European Economic Area or
          Switzerland, you have the right to withdraw from the service contract.
          However, if you purchase a single digital content (e.g., video or
          PDF), you agree to receive that content immediately, thereby losing
          your right of withdrawal. By subscribing to our ongoing service, you
          agree to receive the service immediately. If you exercise your right
          of withdrawal, we will deduct a proportional amount for the service
          provided.
          <br />
          Exercising the Right of Withdrawal
          <br />
          If you have not lost your right of withdrawal, you may exercise this
          right within 14 days of the contract being concluded. To exercise this
          right, you must notify us of your decision to withdraw by sending an
          email to website@caloapp.ai (an unequivocal statement).
          <br />
          You may use the following model withdrawal form, although it is not
          mandatory.
          <br />
          Model Withdrawal Form
          <br />
          To: website@caloapp.ai
          <br />
          Subject: Withdrawal from Contract
          <br />I hereby notify you of my withdrawal from the contract of the
          following service:
          <br />
          Received on:
          <br />
          Registered Email Address:
        </p>

        <div className="section">
          <p className="title-3">
            Money-backs for Purchases Made Through Third-party Platforms
          </p>
        </div>

        <DivWrapper />
      </div>
    </div>
  );
};
